import { TemplateConfig } from '../../template-config.interface';

export const disneySocialThisMonth: TemplateConfig = {
  id: 'social-this-month',
  clientId: 'DISNEY',
  title: 'Este mes',
  description: '',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/este_mes.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/este_mes.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/este_mes_julio.mp4',
  formFields: [],
  promptTemplate: ''
};
